import StoresMap from "./components/StoresMap.jsx";

const { createRoot, createElement } = wp.element;

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".manitoba-stores-map").forEach((el) => {
    const root = createRoot(el);
    root.render(
      createElement(StoresMap, {
        googleMapsApiKey: el.getAttribute("data-googlemaps-apikey"),
        defaultLatLng: el.getAttribute("data-default-latlng"),
        defaultZoom: el.getAttribute("data-default-zoom"),
        markerUrl: el.getAttribute("data-marker-url"),
        activeMarkerUrl: el.getAttribute("data-active-marker-url"),
        countries: el.getAttribute("data-countries"),
        defaultList: window.__DEFAULT_STORES_LIST__ || null,
      })
    );
  });
});
